import { render, staticRenderFns } from "./MemoriaCalculoTabela.vue?vue&type=template&id=5456d171&scoped=true&"
import script from "./MemoriaCalculoTabela.vue?vue&type=script&lang=js&"
export * from "./MemoriaCalculoTabela.vue?vue&type=script&lang=js&"
import style0 from "./MemoriaCalculoTabela.vue?vue&type=style&index=0&id=5456d171&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5456d171",
  null
  
)

export default component.exports